/*==========================
    供應商相關Factory

    Author : Gray
    最後更新時間 : 2016 / 10 / 12
==========================*/
window.InifECShared.factory("SupplierService", ['$q', '$http', function($q, $http) {
	var factory = this;

    // --------------------------------
    // 取得供應商列表
    // --------------------------------
    var getSupplierList = function() {

        if(factory.cache["getSupplierList"]) {
            return factory.cache["getSupplierList"].promise;
        }

        factory.cache["getSupplierList"] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/SupplierAction.do",
            method: "GET",
            params: {
                op: "getSupplierList",
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.cache["getSupplierList"].reject(data.error);
            } else {
                factory.cache["getSupplierList"].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.cache["getSupplierList"].reject(data);
            console.error("[InifEC Error] : SupplierService.getSupplierList request error.");
            console.error("status : " + status);
        });

        return factory.cache["getSupplierList"].promise;

    }

    // --------------------------------
    // 取得供應商Map
    // --------------------------------
    var getSupplierMap = function() {

        if(factory.cache["getSupplierMap"]) {
            return factory.cache["getSupplierMap"].promise;
        }

        factory.cache["getSupplierMap"] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/SupplierAction.do",
            method: "GET",
            params: {
                op: "getSupplierMap",
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.cache["getSupplierMap"].reject(data.error);
            } else {
                factory.cache["getSupplierMap"].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.cache["getSupplierMap"].reject(data);
            console.error("[InifEC Error] : SupplierService.getSupplierMap request error.");
            console.error("status : " + status);
        });

        return factory.cache["getSupplierMap"].promise;

    }

    /*==========================
        Members
    ==========================*/
    factory.cache = {};

    /*==========================
        Methods
    ==========================*/
    factory.getSupplierList = getSupplierList; // 取得供應商列表
    factory.getSupplierMap = getSupplierMap; // 取得供應商Map

	return factory;
}]);